export const FLOATING_BAR_ID = "floating-bar";
export const DEVTOOLS_MODAL_CONTENT_ID = "devtools-modal-content";
export const SHOW_DEVTOOLS_KEY = "showDevTools";
